import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

import { fetchEvent } from '../actions/events';

// This route fetches event data if necessary

const EventRoute = ({ component: Component, ...rest }) => {
  const {
    location: {
      key
    } = {},
    fade = true,
  } = rest;

  const {
    id,
    name
  } = useSelector((state) => state.event.event);

  const dispatch = useDispatch();
  document.title = `${name}: Broadcaster Audience`;

  return (
    <Route
      {...rest}
      render={(props) => {
        const {
          match: {
            params: {
              eventId
            }
          }
        } = props;
        // event routes require event data
        if (!id) {
          dispatch(fetchEvent(eventId));
        }
        if (fade) {
          return (
            <FadeIn key={key}>
              <Component {...props} />
            </FadeIn>
          )
        } else {
          return (<Component {...props} />)
        }
      }}
    />
  )};

const fadeInSettings = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const FadeIn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  animation: ${fadeInSettings} .4s;
`;

export default EventRoute;